/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */

import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DownloadIcon from "@mui/icons-material/Download";
import DeleteIcon from "@mui/icons-material/Delete";
import { useState } from "react";
import toast from "react-hot-toast";
import { Divider, Icon } from "@mui/material";
import { Button, Box } from "@mui/material";
import { descargarDocumetacionGeneral } from "store/download/dowloadActions";
import FormCargarDocumento from "./formCargarDocumento";
import { updateLoadingDescarga } from "store/galeria/galeriaSlice";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import moment from "moment";
import DescargarArchivo from "../../DescargaArchivos";
import ModalContent from "components/ModalContent";
import { store } from "store/store";

function DetallesImagenes({ onClickDel, esExpediente }) {
  const { detalleSolicitud } = useSelector((state) => state.solicitud);
  const { progress, loading } = useSelector((state) => state.download);

  const [descargandoId, setDescargandoId] = useState(null);

  const dispatch = useDispatch();

  const DownloadArchivo = async (ruta, id) => {
    if (!loading && !descargandoId) {
      dispatch(updateLoadingDescarga({ idGaleria: id, valor: true }));
      setDescargandoId(id);
      await dispatch(descargarDocumetacionGeneral(ruta));
      dispatch(updateLoadingDescarga({ idGaleria: id, valor: false }));
      setDescargandoId(null);
    } else {
      toast.error("Solo es posible descargar un archivo a la vez, por favor a espera!!!");
    }
  };
  const usuarioPermisos = store.getState().login?.usuario?.permisos;
  const eliminardocumento = _.filter(
    usuarioPermisos,
    (p) => p.idPermiso == (esExpediente ? 90 : 89)
  );

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} md={3} lg={3}>
          <MDTypography
            component="a"
            href="#"
            variant="caption"
            color="primary"
            fontWeight="medium"
          >
            Fecha
          </MDTypography>
        </Grid>
        <Grid item xs={12} md={9} lg={3}>
          <MDTypography
            component="a"
            href="#"
            variant="caption"
            color="primary"
            fontWeight="medium"
          >
            Titulo
          </MDTypography>
        </Grid>
        <Grid item xs={12} md={9} lg={3}>
          <MDTypography
            component="a"
            href="#"
            variant="caption"
            color="primary"
            fontWeight="medium"
          >
            Descripción
          </MDTypography>
        </Grid>
        <Grid item xs={12} md={9} lg={3}>
          <MDTypography
            component="a"
            href="#"
            variant="caption"
            color="primary"
            fontWeight="medium"
          >
            Acciones
          </MDTypography>
        </Grid>
      </Grid>

      {_.map(detalleSolicitud.galeria, (item) => {
        return (
          <>
            <Grid container spacing={2}>
              <Grid item xs={12} md={3} lg={3}>
                <MDBox>
                  <MDTypography variant="caption" color="white" fontWeight="medium">
                    {moment(item.fechaFoto).format("DD/MM/YYYY")}
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={3} lg={3}>
                <MDBox>
                  <MDTypography variant="caption" color="white" fontWeight="medium">
                    {item.galeriaNombre}
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={3} lg={3}>
                <MDBox>
                  <MDTypography variant="caption" color="white" fontWeight="medium">
                    {item.descripcion}
                  </MDTypography>
                </MDBox>
              </Grid>
              <Grid item xs={12} md={9} lg={3} sx={{ marginBottom: "8'x" }}>
                <Box display="flex" alignItems="center" gap={1}>
                  {descargandoId === item.idGaleria ? (
                    <DescargarArchivo progress={progress} />
                  ) : (
                    <Button
                      variant="contained"
                      sx={{
                        padding: 0,
                        backgroundColor: "#605CA9",
                      }}
                      onClick={() => {
                        DownloadArchivo(item.rutaDescargar, item.idGaleria);
                      }}
                    >
                      <DownloadIcon sx={{ color: "#fff" }} />
                    </Button>
                  )}
                  {eliminardocumento.length == 0 ? null : (
                    <Button
                      variant="contained"
                      sx={{
                        padding: 0,
                        backgroundColor: "#d32f2f",
                        "&:hover": { backgroundColor: "#b71c1c" },
                      }}
                      onClick={() => {
                        onClickDel(item);
                      }}
                    >
                      <DeleteIcon sx={{ color: "#fff" }} />
                    </Button>
                  )}
                </Box>
              </Grid>
            </Grid>
            <Divider style={{ margin: 3 }} />
          </>
        );
      })}
    </>
  );
}

export default DetallesImagenes;
